// extracted by mini-css-extract-plugin
export var animationBlock = "billetStack-module--animationBlock--f33ac";
export var b1 = "billetStack-module--b1--69afa";
export var b2 = "billetStack-module--b2--53725";
export var b3 = "billetStack-module--b3--e367d";
export var billet = "billetStack-module--billet--62dfc";
export var drop = "billetStack-module--drop--127ad";
export var fall1 = "billetStack-module--fall1--7e61b";
export var fall2 = "billetStack-module--fall2--b8deb";
export var fall3 = "billetStack-module--fall3--46b12";
export var reveal = "billetStack-module--reveal--23b81";